<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal-md p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						기관검색
					</h2>
					<a class="close"  @click="$emit('close')">&times;</a>
				</div>
				<div class="modal-body p-10">
					<p class="f-14 m-t-15">
						검색할 '기관명'을 입력하고, 검색 버튼을 클릭하신 후 전체기관명을 선택하세요.
					</p>
					<div class="search-box full-width m-t-30">
						<input id="search" class="form-control round full-width m-b-0" type="text" placeholder="기관명 입력" v-model="keyword">
						<label for="search">검색</label>
					</div>
					<hr class="m-t-15 m-b-15">
					<table class="table text-center table-bordered table-hover">
						<thead>
							<tr class="bg-lightgray">
								<th class="b-r">기관명</th>
								<th>기관주소</th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="!keyword">
								<td colspan="2">
									기관명을 입력하세요.
								</td>
							</tr>
							<tr v-for="(item,idx) in results" :key="'modal-institution-search-'+idx+'-'+hash(item)" @click="$emit('selected', item)">
								<td>{{item.agencyName}}</td>
								<td>{{item.agencyZipcode}} {{item.agencyAddr}} {{item.agencyDetailAddr}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from "axios";
import server from "../statics/server.js";

export default {
	name: "ModalInstitutionSearch",

	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	data: function() {
		return {
			keyword: "",
			results: []
		}
	},

	props: {
		config: Object
	},

	watch: {
		"keyword": function(newValue) {
			axios.post(server.addr()+server.api.AGENCY, {keyword:newValue}).then((response) => {
				this.results = response.data.list;
			})
		}
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>